import React from 'react'
import styles from './MicrositeBuildStatusBanner.module.css'
import { CheckCircle2, Clock, XCircle, HelpCircle } from 'lucide-react'

const META = {
    SUCCESS:  { label: 'Your site is live',        icon: CheckCircle2, tone: 'live' },
    BUILDING: { label: 'Publishing your changes…', icon: Clock,        tone: 'pending' },
    FAILED:   { label: 'Last publish failed',      icon: XCircle,      tone: 'failed' },
    PENDING:  { label: 'Not published yet',        icon: HelpCircle,   tone: 'neutral' }
}

/**
 * MicrositeBuildStatusBanner
 * Large, prominent build state display for the top of MicrositePublish.
 *
 * Usage:
 *   <MicrositeBuildStatusBanner status="SUCCESS" />
 */
const MicrositeBuildStatusBanner = ({ status = 'PENDING' }) => {
    const meta = META[status] || META.PENDING
    const Icon = meta.icon

    return (
        <div className={`${styles.banner} ${styles[`tone_${meta.tone}`]}`}>
            <Icon size={28} className={styles.icon} />
            <div className={styles.label}>{meta.label}</div>
        </div>
    )
}

export default MicrositeBuildStatusBanner